export const BedroomIcon = () => (
  <svg viewBox="0 0 460 460" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="24px">
    <g>
      <path d="M64.47 305.33h331a21.75 21.75 0 0 1 21.75 21.75v92.23h0-374.5 0v-92.22a21.75 21.75 0 0 1 21.75-21.76ZM124.71 190.59v-47.7c0-5.39 4.75-9.75 10.61-9.75H202c5.87 0 10.62 4.36 10.62 9.75V172" />
      <path d="m414.44 316.5-52.62-125.91H98.16L45.56 316.5M361.82 190.59V55.96H98.16v134.63" />
      <path d="M114.86 260.54h240S386.93 259 397.09 275M335.27 190.59v-47.7c0-5.39-4.75-9.75-10.61-9.75H258c-5.87 0-10.62 4.36-10.62 9.75V172" />
    </g>
  </svg>
);
